import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import Layout from 'src/components/Octopath/layout';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SEO = makeShortcode("SEO");
const Menu = makeShortcode("Menu");
const Battle = makeShortcode("Battle");
const layoutProps = {
  _frontmatter
};

const MDXLayout = ({
  children
}) => <Layout>{children}</Layout>;

export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <SEO title="Octopath Traveler II Full Story" mdxType="SEO" />
    <h3 {...{
      "id": "attention"
    }}>{`ATTENTION`}</h3>
    <p>{`This route is outdated in favor of `}<a parentName="p" {...{
        "href": "/Octopath-Traveler-II/Full-Game/All-Extra-Stories"
      }}>{`this route`}</a>{`.`}<br parentName="p"></br>{`
`}{`Only keeping these notes here because they're pre Abating Orb, incase of board splits or whatnot.`}</p>
    <p>{`Start Partitio`}</p>
    <h3 {...{
      "id": "oresrush-partitio-1"
    }}>{`Oresrush (Partitio 1)`}</h3>
    <p>{`Buy 2 Soulstone S.`}<br parentName="p"></br>{`
`}{`Hire closest guy.`}</p>
    <p>{`Kill forced battle with Attack > Arrow of Fortune x2 twice.`}</p>
    <p>{`Pick `}<strong parentName="p">{`$500`}</strong>{`, `}<strong parentName="p">{`Light S`}</strong>{`.`}</p>
    <p>{`Kill 1st battle with Attack > Arrow of Fortune x3`}</p>
    <p>{`Buy from Merchant before Giff.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "buy"
      }}>{`Buy`}</h5>
      <ul>
        <li parentName="ul">{`Short Bow (Equip)`}</li>
      </ul>
      <h5 {...{
        "id": "sell"
      }}>{`Sell`}</h5>
      <ul>
        <li parentName="ul">{`Lump of Silver`}</li>
      </ul>
    </Menu>
    <p>{`Heal before Giff if needed`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "giff"
      }}>{`Giff`}</h4>
      <ol>
        <li parentName="ol">{`Spear Giff`}</li>
        <li parentName="ol">{`Fire S`}</li>
        <li parentName="ol">{`Light S`}</li>
        <li parentName="ol">{`Thunder S`}</li>
        <li parentName="ol">{`Spear x3`}</li>
        <li parentName="ol">{`Arrow of Fortune x4`}</li>
      </ol>
      <p>{`(Might need to heal, fight isn't safe)`}</p>
    </Battle>
    <p>{`Tag `}<strong parentName="p">{`Cropdale`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`$1600`}</strong>{`. Tag `}<strong parentName="p">{`Crackridge Harbor`}</strong>{`, warp to `}<strong parentName="p">{`Oresrush`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Tag `}<strong parentName="p">{`Ryu`}</strong>{`, warp `}<strong parentName="p">{`Crackridge Harbor`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Take boat to `}<strong parentName="p">{`New Delsta Anchorage`}</strong>{`.`}</p>
    <p>{`Tag `}<strong parentName="p">{`Abandoned Village`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Get `}<strong parentName="p">{`Oswald`}</strong>{`. Go to Cape Cold`}</p>
    <h3 {...{
      "id": "cape-cold"
    }}>{`Cape Cold`}</h3>
    <p>{`Mug Retired Scholar for Gold Items (Defend, Staff, Fireball x4)`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`$2000`}</strong>{`. TP `}<strong parentName="p">{`Abandoned Village`}</strong>{` and head to Black Market.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`Herb of Serenity`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "soulstone-merchant-sell"
      }}>{`Soulstone Merchant (Sell)`}</h5>
      <ul>
        <li parentName="ul">{`Gold Items`}</li>
        <li parentName="ul">{`Herb of Serenity`}</li>
      </ul>
      <h5 {...{
        "id": "soulstone-merchant-buy"
      }}>{`Soulstone Merchant (Buy)`}</h5>
      <ul>
        <li parentName="ul">{`1 Ice S`}</li>
        <li parentName="ul">{`1 Thunder S`}</li>
        <li parentName="ul">{`8 Fire M`}</li>
        <li parentName="ul">{`1 Ice M`}</li>
        <li parentName="ul">{`1 Shadow M`}</li>
      </ul>
    </Menu>
    <p>{`Go to `}<strong parentName="p">{`New Delsta`}</strong>{`.`}</p>
    <h3 {...{
      "id": "new-delsta"
    }}>{`New Delsta`}</h3>
    <p>{`Get Throne, Battle Ice S + Attack x2`}<br parentName="p"></br>{`
`}{`Steal `}<strong parentName="p">{`Ice S, Wind S, Light S`}</strong>{` from Old Man.`}<br parentName="p"></br>{`
`}{`Go to Weapon Shop`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "buy-1"
      }}>{`Buy`}</h5>
      <p>{`Unerring Ring`}</p>
    </Menu>
    <p>{`TP `}<strong parentName="p">{`New Delsta Anchorage`}</strong>{`. Take the ship to `}<strong parentName="p">{`Toto'haha`}</strong>{`.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`DONT ACCIDENTLY TAKE IT TO CRACKRIDGE`}</strong>{`.`}</p>
    <h3 {...{
      "id": "beasting-bay-anchorage"
    }}>{`Beasting Bay: Anchorage`}</h3>
    <p>{`Buy `}<strong parentName="p">{`White Powder`}</strong>{` from lady.`}<br parentName="p"></br>{`
`}{`Take boat to `}<strong parentName="p">{`Canalbrine`}</strong>{`.`}</p>
    <h3 {...{
      "id": "canalbrine-temenos-ch2-start"
    }}>{`Canalbrine (Temenos Ch2 Start)`}</h3>
    <p>{`Get Castii. Turn in quest for `}<strong parentName="p">{`$4000 & Crit M`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Go to Weapon Shop, buy `}<strong parentName="p">{`Critical Earring`}</strong>{`. Head to `}<strong parentName="p">{`Conning Creek`}</strong>{`.`}</p>
    <p>{`TP `}<strong parentName="p">{`Ryu`}</strong>{`.`}</p>
    <h3 {...{
      "id": "ryu"
    }}>{`Ryu`}</h3>
    <p>{`Get Hikari, replace Castti. Battle Wind S + Light S.`}<br parentName="p"></br>{`
`}{`TP `}<strong parentName="p">{`Canalbrine`}</strong>{`, head to `}<strong parentName="p">{`Conning Creek`}</strong>{`.`}</p>
    <p>{`West Canalbrine Coast: Switch to night before battle, Fire M. Should get enough JP for EM.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "learn-skills"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Partitio: Collect + Hired Help`}</li>
        <li parentName="ul">{`Oswald: Lightning Bolt + Elemental Barrage`}</li>
        <li parentName="ul">{`Throne: Armor Corrosive`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Partitio: Grow on Trees`}</li>
        <li parentName="ul">{`Oswald: Evasive Maneuvers`}</li>
      </ul>
    </Menu>
    <p>{`First screen clear with Fire M.`}<br parentName="p"></br>{`
`}{`2nd screen walk.`}<br parentName="p"></br>{`
`}{`1st Conning Creek screen kill with Fire M. Watch Throne level.`}<br parentName="p"></br>{`
`}{`2nd Conning Creek screen kill with Fire M or walk and Mug. Killing will give Oswald enough levels to survive Clarissa.`}</p>
    <h3 {...{
      "id": "conning-creek-oswald-ch3-start"
    }}>{`Conning Creek (Oswald Ch3 Start)`}</h3>
    <p>{`Get `}<strong parentName="p">{`Rainbow Bottle`}</strong>{`. TP `}<strong parentName="p">{`New Delsta`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Go to Inventor, kill with Shadow M.`}<br parentName="p"></br>{`
`}{`Get Inventor + Upgrades, head to `}<strong parentName="p">{`Clockbank`}</strong>{`.`}</p>
    <p>{`Screen before Clockbank pick `}<strong parentName="p">{`$6300`}</strong>{`, reset steps with Thief Shrine, enter `}<strong parentName="p">{`Clockbank`}</strong>{`. `}</p>
    <h3 {...{
      "id": "clockbank-partitio-ch2"
    }}>{`Clockbank (Partitio Ch.2)`}</h3>
    <p>{`Hire guy for 20% extra Collect.`}<br parentName="p"></br>{`
`}{`Do story stuff until you deliver `}<strong parentName="p">{`Clockite`}</strong>{`, then warp to `}<strong parentName="p">{`Conning Creek`}</strong>{`.`}</p>
    <h3 {...{
      "id": "conning-creek-oswald-ch3-continued"
    }}>{`Conning Creek (Oswald Ch3 Continued)`}</h3>
    <p>{`Go to house, pick `}<strong parentName="p">{`Fire M`}</strong>{`.`}</p>
    <blockquote>
      <p parentName="blockquote">{`You need a bit over 400HP for this fight w/o A Step Ahead. If someone's short just do Inventor menu early.`}</p>
    </blockquote>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "clarissa-8212hp-5s-spear-dagger-thunder"
      }}>{`Clarissa 8212HP 5S (Spear Dagger Thunder)`}</h4>
      <ul>
        <li parentName="ul">{`Oswald: Lightning Bolt`}</li>
        <li parentName="ul">{`Throne: Attack x2`}</li>
        <li parentName="ul">{`Hikari: Spear x2`}</li>
        <li parentName="ul">{`Partitio: Defend, Guards x3`}</li>
      </ul>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Clockbank`}</strong>{`.`}</p>
    <h3 {...{
      "id": "clockbank-partitio-ch2-continued"
    }}>{`Clockbank (Partitio Ch2 Continued)`}</h3>
    <p>{`Hire guy for Story.`}<br parentName="p"></br>{`
`}{`Buy `}<strong parentName="p">{`Mighty Belt`}</strong>{`.`}</p>
    <p>{`Forced fight Fire M.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`$7000`}</strong>{`. Kill battle with Fire M`}<br parentName="p"></br>{`
`}{`Don't need night here. Need Latent on Partitio.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Hikari: Inventor`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills-1"
      }}>{`Equip Skills`}</h5>
      <p>{`All: A Step Ahead`}</p>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "garnet-23000hp-4s-spear-axe-fire-thunder"
      }}>{`Garnet 23000HP 4S (Spear Axe Fire Thunder)`}</h4>
      <h5 {...{
        "id": "turn-1"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Partitio: LATENT Collect x4`}</li>
        <li parentName="ul">{`Oswald: Lightning Bolt`}</li>
        <li parentName="ul">{`Throne: Fire M`}</li>
        <li parentName="ul">{`Castti: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Hikari: Elemental Bottle x3`}</li>
        <li parentName="ul">{`Partitio: Collect x4`}</li>
        <li parentName="ul">{`Throne: Armor Corrosive`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Partitio: Latent Guards x4`}</li>
      </ul>
    </Battle>
    <p>{`Go to `}<strong parentName="p">{`Flamechurch`}</strong>{`.`}</p>
    <h3 {...{
      "id": "flamechurch"
    }}>{`Flamechurch`}</h3>
    <p>{`Get Temenos, smack Insurgent with Fire S / Daggers / Staffs / Fireball.`}<br parentName="p"></br>{`
`}{`TP `}<strong parentName="p">{`Conning Creek`}</strong>{`.`}</p>
    <h3 {...{
      "id": "conning-creek-oswald-ch3-continued-1"
    }}>{`Conning Creek (Oswald Ch3 continued)`}</h3>
    <p>{`Kill fight in Guard Outpost with `}<strong parentName="p">{`Fire M`}</strong>{`.`}</p>
    <p>{`Do this menu before Stenvar, need Boost Start.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`SWITCH TO NIGHT`}</strong>{` before Stenvar.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs-1"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Partitio: Donate BP`}</li>
        <li parentName="ul">{`Throne: Inventor`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills-2"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Partitio: Boost Start`}</li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "stenvar-19000hp-5s-sword-spear-bow-thunder-shadow"
      }}>{`Stenvar 19000HP 5S (Sword Spear Bow Thunder Shadow)`}</h4>
      <h5 {...{
        "id": "turn-1-1"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Partitio: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-1"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Partitio: HHB x4`}</li>
      </ul>
    </Battle>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "items"
      }}>{`Items`}</h5>
      <ul>
        <li parentName="ul">{`Axe of Avarice: Throne`}</li>
        <li parentName="ul">{`Mighty Belt: Throne`}</li>
      </ul>
    </Menu>
    <p>{`TP `}<strong parentName="p">{`Crackridge Harbor`}</strong>{`.`}</p>
    <p>{`Either run (escape rate should be decent) or clear with Catapult Axe x2`}<br parentName="p"></br>{`
`}{`Southern Crackridge Wilds: switch to night before you get the battle, clear with Catapult x3 Axe`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`$6400`}</strong>{`.`}</p>
    <h3 {...{
      "id": "western-crackridge-wilds"
    }}>{`Western Crackridge Wilds`}</h3>
    <p>{`Switch to night, clear battle.`}<br parentName="p"></br>{`
`}{`Get `}<strong parentName="p">{`Merchant Guild`}</strong>{`. Pick `}<strong parentName="p">{`Thunder M`}</strong>{`. Mug Merchant to reset step counter. Tag `}<strong parentName="p">{`Crackridge`}</strong>{`.`}</p>
    <p>{`TP `}<strong parentName="p">{`Flamechurch`}</strong>{`. Head to `}<strong parentName="p">{`Montwise`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Run from small battle, kill Borderfall battle with nighttime Catapult x2`}</p>
    <h3 {...{
      "id": "montwise-oswald-ch4"
    }}>{`Montwise (Oswald Ch4)`}</h3>
    <p>{`Buy `}<strong parentName="p">{`Light M & Shadow M`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs-2"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Temenos: Inventor`}</li>
        <li parentName="ul">{`Throne: Merchant, Collect + Donate BP + Hired Help`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills-3"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Temenos: A Step Ahead`}</li>
        <li parentName="ul">{`Throne: Grow on Trees, Boost Start`}</li>
      </ul>
    </Menu>
    <p>{`Underground Laboratory: Walk to pick `}<strong parentName="p">{`$14000`}</strong>{`. Walk to 2nd door from 4 door section, Travel Banter.`}<br parentName="p"></br>{`
`}{`Run rest, pick `}<strong parentName="p">{`Fire L`}</strong>{`. `}<strong parentName="p">{`SWITCH TO NIGHT`}</strong></p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "grieving-golem-620000hp-7s-spear-staff-wind-light"
      }}>{`Grieving Golem 620000HP 7S (Spear Staff Wind Light)`}</h4>
      <h5 {...{
        "id": "turn-1-2"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Partitio: Attack`}</li>
        <li parentName="ul">{`Throne: Spear`}</li>
        <li parentName="ul">{`Oswald: Defend`}</li>
        <li parentName="ul">{`Temenos: Attack x2`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-2"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Oswald: Attack x3`}</li>
        <li parentName="ul">{`Temenos: Critical Scope`}</li>
        <li parentName="ul">{`Merchants: Defend`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`Check Throne's Latent Power here, want it full.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-3-1"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Merchants: HHGx4 & HHBx4`}</li>
        <li parentName="ul">{`Someone: M Stone`}</li>
      </ul>
    </Battle>
    <p>{`Stay at inn if Throne Latent isn't full.`}<br parentName="p"></br>{`
`}{`Go to Tavern, switch Oswald for Hikari.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Hear a Tale`}</strong>{` to start `}<strong parentName="p">{`Hikari 2`}</strong>{`.`}</p>
    <h3 {...{
      "id": "hikari-ch2"
    }}>{`Hikari Ch.2`}</h3>
    <p>{`Battle 1: Defend, Spear x3, M Stone`}<br parentName="p"></br>{`
`}{`Battle 2: Ice M`}<br parentName="p"></br>{`
`}{`Zeto: Thunder M, Attack x3, M Stone`}</p>
    <p>{`If no M Stones left, buy `}<strong parentName="p">{`Wind M`}</strong>{` from guy sitting on bench.`}</p>
    <p>{`Bandelam: Fire L, M Stone`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "bandelam-20000hp-6s-spear-dagger-axe-fire-light"
      }}>{`Bandelam 20000HP 6S (Spear Dagger Axe Fire Light)`}</h4>
      <h5 {...{
        "id": "turn-1-3"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Partitio: Attack`}</li>
        <li parentName="ul">{`Hikari: Defend`}</li>
        <li parentName="ul">{`Throne: AC`}</li>
        <li parentName="ul">{`Temenos: Axe x2`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-3"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Hikari: Spear x3`}</li>
        <li parentName="ul">{`Merchant: HHG x4`}</li>
      </ul>
    </Battle>
    <p>{`Switch to Night, re-enter Arena. Ambush Fainthearted Youth.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "yurinas-30000hp-6s-sword-dagger-axe-ice-wind"
      }}>{`Yurinas 30000HP 6S (Sword Dagger Axe Ice Wind)`}</h4>
      <p>{`T1: Defend / Armor Corrosive if 1st T2`}<br parentName="p"></br>{`
`}{`T2: `}<strong parentName="p">{`Latent`}</strong>{` Armor Corrosive, HHV x4`}</p>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Canalbrine`}</strong>{`.`}</p>
    <h3 {...{
      "id": "canalbrine-temenos-ch2"
    }}>{`Canalbrine (Temenos Ch2)`}</h3>
    <p>{`Talk to Tavern Keeper`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "party"
      }}>{`Party`}</h5>
      <p>{`Oswald > Hikari`}</p>
      <h5 {...{
        "id": "jobs-3"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Oswald: Merchant, Collect + Donate BP + Hired Help`}</li>
        <li parentName="ul">{`Throne: `}<strong parentName="li">{`HP THIEF`}</strong>{`, Inventor`}</li>
      </ul>
      <h5 {...{
        "id": "equipment"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Optimize, Champions Belt`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills-4"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Oswald: Grow On Trees, Boost Start`}</li>
      </ul>
    </Menu>
    <p>{`Coerce top left suspect.`}<br parentName="p"></br>{`
`}{`Mystic Staff, Staff, Staff x4.`}</p>
    <p>{`Switch to day.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`Slumber Sage`}</strong>{`.`}</p>
    <p>{`WALK dungeon, Pick `}<strong parentName="p">{`$5600`}</strong>{`. Don't need to switch to night.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "vados-the-architecht-14000hp-6s-spear-dagger-ice-light"
      }}>{`Vados the Architecht 14000HP 6S (Spear Dagger Ice Light)`}</h4>
      <h5 {...{
        "id": "turn-1-4"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Partitio: Attack x3`}</li>
        <li parentName="ul">{`Oswald: Defend`}</li>
        <li parentName="ul">{`Throne: Attack x3`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-4"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Oswald: HHG x4`}</li>
      </ul>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Crackridge`}</strong>{`.`}</p>
    <h3 {...{
      "id": "crackridge-temenos-ch3"
    }}>{`Crackridge (Temenos Ch3)`}</h3>
    <p>{`Abandoned Road switch to night before battle, Catapult x3`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`$9200`}</strong>{`. Fellsun Ruins walk until 1st cutscene.`}<br parentName="p"></br>{`
`}{`Kill battle outside with night + Catapult x3`}</p>
    <p><strong parentName="p">{`Western Gravell Wilds`}</strong>{`: Kill 2 battles with Night + HHG x4`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`Thunder L`}</strong>{`. Pick `}<strong parentName="p">{`$23000`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "learn-skills-1"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Temenos: Last 3 Cleric Skills`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skils"
      }}>{`Equip Skils`}</h5>
      <ul>
        <li parentName="ul">{`Temenos: Evil Ward`}</li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "gravell-oswald-ch4"
    }}>{`Gravell (Oswald Ch4)`}</h3>
    <p>{`Steal `}<strong parentName="p">{`Lily of the Light & Light M`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Buy `}<strong parentName="p">{`Light M & Shadow M`}</strong>{`.`}</p>
    <p>{`Mug 1: Defend, HHG x4, M Stone`}<br parentName="p"></br>{`
`}{`Mug 2: Lightning Bolt, Lightning Bolt, HHG x4`}<br parentName="p"></br>{`
`}{`Mug 3: Defend, HHG x4, M Stone. Watch Guards hits, if 3 or more hits only hit for 1600ish then throw an L Stone instead.`}<br parentName="p"></br>{`
`}{`Mug 4: Thunder L + M Stone`}<br parentName="p"></br>{`
`}{`Mug 5: Defend, HHB x4`}</p>
    <p>{`Duskruin: Walk till bit past start of big staircase, switch to night.`}</p>
    <p>{`Kill battle with Guards, walk rest. Pick `}<strong parentName="p">{`$25000`}</strong>{`.`}<br parentName="p"></br>{`
`}<em parentName="p">{`You only have money for 1 kill here, or rather 3 total between Gravell and this dungeon`}</em></p>
    <p><strong parentName="p">{`SWITCH TO NIGHT`}</strong>{` before trigger.`}<br parentName="p"></br>{`
`}{`Remnants: Beastling x4`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "harvey-80000hp-10s-spear-axe-fire-ice-thunder"
      }}>{`Harvey 80000HP 10S (Spear Axe Fire Ice Thunder)`}</h4>
      <h5 {...{
        "id": "turn-1-5"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Partitio: Attack`}</li>
        <li parentName="ul">{`Oswald: Elemental Barrage`}</li>
        <li parentName="ul">{`Throne: `}<strong parentName="li">{`Spring Boots`}</strong>{` self`}</li>
        <li parentName="ul">{`Temenos: Attack`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-5"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Elemental Bottle x4`}</li>
        <li parentName="ul">{`Partitio: Donate BP Oswald`}</li>
        <li parentName="ul">{`Oswald: Donate BP Partitio`}</li>
        <li parentName="ul">{`Temenos: Shadow L`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-2"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Crit Scope`}</li>
        <li parentName="ul">{`Partitio: Guards x4`}</li>
        <li parentName="ul">{`Oswald: Beastlings x4`}</li>
      </ul>
      <h5 {...{
        "id": "turn-4"
      }}>{`Turn 4`}</h5>
      <ul>
        <li parentName="ul">{`Throne: AC`}</li>
        <li parentName="ul">{`Partitio: Collect x3`}</li>
        <li parentName="ul">{`Oswald: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-5"
      }}>{`Turn 5`}</h5>
      <ul>
        <li parentName="ul">{`Oswald: Beastlings x4`}</li>
      </ul>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Oresrush`}</strong>{`.`}</p>
    <h3 {...{
      "id": "oresrush-throne-ch2"
    }}>{`Oresrush (Throne Ch.2)`}</h3>
    <p>{`Steal/Buy `}<strong parentName="p">{`Sturdy Pickaxe`}</strong>{` from NPC in Weapon Shop.`}<br parentName="p"></br>{`
`}{`Finish Chapter, TP `}<strong parentName="p">{`New Delsta`}</strong>{`.`}</p>
    <h3 {...{
      "id": "new-delsta-oswald-partitio-ch1"
    }}>{`New Delsta (Oswald Partitio Ch1)`}</h3>
    <p>{`Hire NPC by Tavern. (25% refund on Purchases)`}<br parentName="p"></br>{`
`}{`Do chapter. TP `}<strong parentName="p">{`Cape Cold`}</strong>{`, go towards `}<strong parentName="p">{`Winterbloom`}</strong>{`. Get `}<strong parentName="p">{`Scholar Guild`}</strong>{` on the way.`}</p>
    <h3 {...{
      "id": "winterbloom-throne-ch2"
    }}>{`Winterbloom (Throne Ch2)`}</h3>
    <p>{`Mug guy for `}<strong parentName="p">{`Fort L`}</strong></p>
    <p>{`Switch to Night for Boss`}</p>
    <Battle mdxType="Battle">
      <h5 {...{
        "id": "bergomi-15000hp-4s-sword-bow-fire"
      }}>{`Bergomi 15000HP 4S (Sword Bow Fire)`}</h5>
      <p>{`HHB x3`}</p>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Gravell`}</strong>{`.`}</p>
    <h3 {...{
      "id": "gravell"
    }}>{`Gravell`}</h3>
    <p>{`Steal `}<strong parentName="p">{`Sharp L`}</strong>{`. Go to Tavern.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "party-1"
      }}>{`Party`}</h5>
      <p>{`Castii > Oswald`}</p>
      <h5 {...{
        "id": "jobs-4"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Partitio: Scholar, 4 Skills`}</li>
        <li parentName="ul">{`Temenos: Merchant, 3 Skills`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills-5"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Partitio: -Grow On Trees +EM +Extra Experience`}</li>
        <li parentName="ul">{`Castti: A Step Ahead`}</li>
        <li parentName="ul">{`Temenos: +Boost Start +Grow on Trees`}</li>
      </ul>
    </Menu>
    <p>{`Soothe guy guarding house, get `}<strong parentName="p">{`Armmaster`}</strong>{`.`}<br parentName="p"></br>{`
`}{`TP `}<strong parentName="p">{`Toto'haha Anchorage`}</strong></p>
    <h3 {...{
      "id": "beastling-bay-anchorage"
    }}>{`Beastling Bay Anchorage`}</h3>
    <p>{`Probably getting Shadow battle here. Break with Axe & Spear and run.`}<br parentName="p"></br>{`
`}{`Run to `}<strong parentName="p">{`Tropu'hopu`}</strong>{`.`}</p>
    <h3 {...{
      "id": "tropuhopu"
    }}>{`Tropu'hopu`}</h3>
    <p>{`Go to Item Shop`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "item-sell"
      }}>{`Item Sell`}</h5>
      <ul>
        <li parentName="ul">{`Conqueror's Blade`}</li>
        <li parentName="ul">{`Soldier's Spear`}</li>
      </ul>
    </Menu>
    <p>{`Steal `}<strong parentName="p">{`Fort M`}</strong>{`, maybe `}<strong parentName="p">{`Ice L`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Go to Inn. `}<strong parentName="p">{`Rest at Inn`}</strong>{`. Hire NPC for 20% off purchases.`}<br parentName="p"></br>{`
`}{`Go buy Boat!`}</p>
    <h3 {...{
      "id": "sea"
    }}>{`Sea`}</h3>
    <p>{`Pick `}<strong parentName="p">{`Reinforcing Jam`}</strong>{`, `}<strong parentName="p">{`$20000`}</strong>{`.`}<br parentName="p"></br>{`
`}{`TP `}<strong parentName="p">{`New Delsta Harbor`}</strong>{`, get back on boat. Pick `}<strong parentName="p">{`EXP Augmentor`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "formation"
      }}>{`Formation`}</h5>
      <ul>
        <li parentName="ul">{`Partitio > Throne`}</li>
      </ul>
      <h5 {...{
        "id": "items-1"
      }}>{`Items`}</h5>
      <ul>
        <li parentName="ul">{`EXP Augmentor: Temenos`}</li>
        <li parentName="ul">{`All relevant Nuts onto Throne`}</li>
      </ul>
    </Menu>
    <p>{`TP `}<strong parentName="p">{`Montwise`}</strong>{`.`}</p>
    <h3 {...{
      "id": "montwise-throne-ch3-start"
    }}>{`Montwise (Throne Ch3 Start)`}</h3>
    <p>{`Exit and run towards `}<strong parentName="p">{`Merry Hills.`}</strong><br parentName="p"></br>{`
`}{`Kill 1st battle with night + Catapult x3`}<br parentName="p"></br>{`
`}{`Kill 2nd battle with some combo of Guards and/or Catapult`}</p>
    <h3 {...{
      "id": "merry-hills"
    }}>{`Merry Hills`}</h3>
    <p>{`Purchase `}<strong parentName="p">{`Diamond Dagger`}</strong>{`. TP `}<strong parentName="p">{`Conning Creek`}</strong>{`, head to `}<strong parentName="p">{`Sai`}</strong>{`.`}</p>
    <h3 {...{
      "id": "sai-castti-ch2"
    }}>{`Sai (Castti Ch2)`}</h3>
    <p>{`Get `}<strong parentName="p">{`Warrior Guild`}</strong>{`. Steal `}<strong parentName="p">{`Fort S`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h3 {...{
        "id": "items-2"
      }}>{`Items`}</h3>
      <ul>
        <li parentName="ul">{`Fort S x2: Throne`}</li>
        <li parentName="ul">{`Diamond Dagger: Throne`}</li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "sand-lion-22500hp-5s-spear-axe-ice-light-shadow"
      }}>{`Sand Lion 22500HP 5S (Spear Axe Ice Light Shadow)`}</h4>
      <h5 {...{
        "id": "turn-1-6"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Throne: HP Thief x3`}</li>
        <li parentName="ul">{`Castti: Attack x2`}</li>
        <li parentName="ul">{`Partitio: Attack x3`}</li>
        <li parentName="ul">{`Temenos: Donate BP x3 Throne`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-6"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Throne: HP Thief x4`}</li>
      </ul>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Winterbloom`}</strong>{`.`}</p>
    <h3 {...{
      "id": "winterbloom-castti-ch2"
    }}>{`Winterbloom (Castti Ch2)`}</h3>
    <Battle mdxType="Battle">
      <h5 {...{
        "id": "plukk-16000hp-mikk-12000hp-makk-13000hp"
      }}>{`Plukk 16000HP, Mikk 12000HP, Makk 13000HP`}</h5>
      <p>{`HHGx4, Catapult x4`}</p>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Abandoned Village`}</strong></p>
    <h3 {...{
      "id": "abandoned-village-castti-ch3"
    }}>{`Abandoned Village (Castti Ch3)`}</h3>
    <p>{`Pick `}<strong parentName="p">{`$12600`}</strong>{`. Kill battle with Night + Catapult. `}<strong parentName="p">{`WATCH YOUR JP`}</strong>{`.`}<br parentName="p"></br>{`
`}{`TP `}<strong parentName="p">{`Sai`}</strong>{`, head to `}<strong parentName="p">{`Wellgrove`}</strong>{`. Kill battles until Throne has 4500JP.`}</p>
    <h3 {...{
      "id": "wellgrove-partitio-ch3-start"
    }}>{`Wellgrove (Partitio Ch3 Start)`}</h3>
    <p>{`Exit, run to `}<strong parentName="p">{`Timberlain`}</strong>{`. Kill stuff till Throne has `}<strong parentName="p">{`4500JP`}</strong>{` for `}<strong parentName="p">{`Life in the Shadows`}</strong></p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs-5"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Thief, all skills, Inventor`}</li>
        <li parentName="ul">{`Castti: Merchant, Collect + Donate BP + Hired Help`}</li>
        <li parentName="ul">{`Temenos: Scholar, Lighting Bolt + `}<strong parentName="li">{`Elemental Barrage`}</strong></li>
      </ul>
      <h5 {...{
        "id": "equip-skills-6"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Throne: +Life in the Shadow`}</li>
        <li parentName="ul">{`Castti: +Grow on Trees + Boost Start`}</li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "timberain-castti-ch4"
    }}>{`Timberain (Castti Ch4)`}</h3>
    <p><em parentName="p">{`Trosseau strat requires Latent on Partitio and Temenos. Rest at Inn if needed`}</em>{`.`}<br parentName="p"></br>{`
`}<em parentName="p">{`Can replace Partitio Latent with Merchant 1 Attack x3, Merchant 2 Pom L Merchant 1`}</em><br parentName="p"></br>{`
`}{`Steal `}<strong parentName="p">{`Wind L, Light L`}</strong>{`.`}</p>
    <p>{`Kill battles at night with Catapult x3/4`}<br parentName="p"></br>{`
`}{`1st screen switch to night start of leftmost stairs.`}<br parentName="p"></br>{`
`}{`2nd screen switch to night bit before sleeping guard. Will probably want to walk a bit of this screen too.`}</p>
    <blockquote>
      <p parentName="blockquote">{`If just Temenos missing Latent, have him attack x3 and replace Castti attack with Shadow L.`}</p>
    </blockquote>
    <p><strong parentName="p">{`SWITCH TO NIGHT`}</strong></p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "trosseau-95000hp-8s-spear-axe-ice-dark"
      }}>{`Trosseau 95000HP 8S (Spear Axe Ice Dark)`}</h4>
      <h5 {...{
        "id": "turn-1-7"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Crit Scope`}</li>
        <li parentName="ul">{`Castti: Attack`}</li>
        <li parentName="ul">{`Partitio: Latent + Attack x3`}</li>
        <li parentName="ul">{`Temenos: Latent + Elemental Barrage x3`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-7"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Latent HP Thief x4 + HP Thief`}</li>
        <li parentName="ul">{`Castti: HHB x4`}</li>
        <li parentName="ul">{`Partitio: HHB x4`}</li>
        <li parentName="ul">{`Temenos: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-3"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Olive & Collect, Attack`}</li>
      </ul>
    </Battle>
    <p><em parentName="p">{`If Trosseau killed Throne, will need to Stay at Inn before Kaldena`}</em>{`.`}</p>
    <p>{`TP `}<strong parentName="p">{`Cropdale`}</strong></p>
    <h3 {...{
      "id": "cropdale"
    }}>{`Cropdale`}</h3>
    <p>{`Get Agnea, replace Castti. TP `}<strong parentName="p">{`Merry Hills`}</strong>{`. Go fight Assassins.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "assassins"
      }}>{`Assassins`}</h4>
      <h5 {...{
        "id": "turn-1-8"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Spring Boots Partitio`}</li>
        <li parentName="ul">{`Partitio: HHM`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-8"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Partitio: HHB x4`}</li>
        <li parentName="ul">{`Throne: Catapult x4 (Needed?)`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-4"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Partitio: Latent HHB x4`}</li>
      </ul>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`New Delsta`}</strong>{`.`}</p>
    <h3 {...{
      "id": "new-delsta-agnea-ch2"
    }}>{`New Delsta (Agnea Ch2)`}</h3>
    <p>{`Entreat `}<strong parentName="p">{`Fort M & Nourish M`}</strong>{`.`}<br parentName="p"></br>{`
`}{`After doing 1st Allure:`}</p>
    <p>{`TP `}<strong parentName="p">{`Montwise`}</strong>{`, head to `}<strong parentName="p">{`Stormhail`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Ambush Guard. Switch back to Day. Run from everything on this trip.`}</p>
    <h3 {...{
      "id": "stormhail-temenos-ch3"
    }}>{`Stormhail (Temenos Ch3)`}</h3>
    <p>{`After Crick Guides `}<strong parentName="p">{`switch to day`}</strong>{`.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`SWITCH TO NIGHT`}</strong>{` before end of last stairs.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "deputy-cubaryi-54000hp-5s-spear-axe-staff-19200-collect"
      }}>{`Deputy Cubaryi 54000HP 5S (Spear Axe Staff) $19200 Collect`}</h4>
      <h5 {...{
        "id": "turn-1-9"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Attack / Defend if before Temenos`}</li>
        <li parentName="ul">{`Partitio: Attack`}</li>
        <li parentName="ul">{`Temenos: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-9"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Temenos: Attack x4`}</li>
        <li parentName="ul">{`Throne: HP Thief x4`}</li>
        <li parentName="ul">{`Partitio: HHB x4`}</li>
      </ul>
    </Battle>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs-6"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Temenos: Merchant, 2 Skills, Scholar`}</li>
        <li parentName="ul">{`Partitio: 2 Skills`}</li>
        <li parentName="ul">{`Agnea: Stimulate, Merchant, Collect + Ember + Donate BP + Hired Help`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills-7"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Temenos: -Grow on Trees +Full Power`}</li>
        <li parentName="ul">{`Partitio: -Boost Start +Full Power`}</li>
        <li parentName="ul">{`Agnea: All Skills`}</li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "new-delsta-agnea-ch2-continued"
    }}>{`New Delsta (Agnea Ch2 Continued)`}</h3>
    <p>{`Take bottom path and Allure Lady on the way.`}<br parentName="p"></br>{`
`}{`Switch to night before boss`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "lamani"
      }}>{`La'mani`}</h4>
      <p>{`If Throne first, Defend and other knock off 3 shield.`}<br parentName="p"></br>{`
`}{`If not, knock off 3 Shield with Attack x3 (Latent with Temenos) and Throne HP Thief x3`}<br parentName="p"></br>{`
`}<em parentName="p">{`Want Throne to break to build Latent (and short damage)`}</em></p>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Tropu'hopu`}</strong></p>
    <h4 {...{
      "id": "tropuhopu-agnea-ch3"
    }}>{`Tropu'hopu (Agnea Ch3)`}</h4>
    <p>{`Entreat `}<strong parentName="p">{`Light Nut L`}</strong>{`.`}<br parentName="p"></br>{`
`}{`After finishing Chapter run to `}<strong parentName="p">{`Nameless Village`}</strong>{`.`}</p>
    <h3 {...{
      "id": "nameless-village-temenos-ch4"
    }}>{`Nameless Village (Temenos Ch4)`}</h3>
    <p>{`Guide Story Guy. Steal `}<strong parentName="p">{`Nourish L`}</strong>{`.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`SWITCH TO NIGHT`}</strong>{` Before Fight`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "kaldena-100000hp-8s-spear-staff-ice-wind-collect-1200"
      }}>{`Kaldena 100000HP 8S (Spear Staff Ice Wind) Collect $1200`}</h4>
      <ul>
        <li parentName="ul">{`Throne: Crit Scope`}</li>
        <li parentName="ul">{`Agnea: Donate BP Throne`}</li>
        <li parentName="ul">{`Partitio: Latent Attack x3`}</li>
        <li parentName="ul">{`Temenos: Latent Elemental Barrage x3`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-10"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Latent HP Thief x4, HP Thief x2`}</li>
        <li parentName="ul">{`Agnea: HHB x4`}</li>
        <li parentName="ul">{`Partitio: HHB x4`}</li>
        <li parentName="ul">{`Temenos: Nothing`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-5"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Attack`}</li>
      </ul>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Wellgrove`}</strong>{`.`}</p>
    <h3 {...{
      "id": "wellgrove-partitio-ch3-continued"
    }}>{`Wellgrove (Partitio Ch3 Continued)`}</h3>
    <blockquote>
      <p parentName="blockquote">{`If you want to Entreat the 2 L Stones, delay the swap and menu until you hire the merchant in the tavern.`}</p>
    </blockquote>
    <p>{`After Tavern cutscene, `}<strong parentName="p">{`Swap Hikari > Agnea`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Get `}<strong parentName="p">{`Dancer Guild`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs-7"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Warrior, All Skills, Inventor`}</li>
        <li parentName="ul">{`Hikari: Merchant, Collect + Donate BP + Hired Help`}</li>
        <li parentName="ul">{`Partitio: Dancer`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills-8"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Throne: -Grow on Trees +Surpassing Power`}</li>
        <li parentName="ul">{`Hikari: +Grow on Trees +Boost Start`}</li>
      </ul>
    </Menu>
    <p>{`After buying stuff, `}<strong parentName="p">{`Switch to Night`}</strong></p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "thurston-35000hp-4s-sword-axe-bow-ice-wind-collect-17000"
      }}>{`Thurston 35000HP 4S (Sword Axe Bow Ice Wind) Collect $17000`}</h4>
      <h4 {...{
        "id": "steam-engine-7500hp-spear-dagger-fire-thunder"
      }}>{`Steam Engine 7500HP (Spear Dagger Fire Thunder)`}</h4>
      <h5 {...{
        "id": "turn-1-10"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Throne: HP Thief x3 Steam Engine`}</li>
        <li parentName="ul">{`Hikari: Defend`}</li>
        <li parentName="ul">{`Partitio: Latent Donate BP x3 Throne`}</li>
        <li parentName="ul">{`Temenos: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-11"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Temenos: LATENT Attack x4`}</li>
        <li parentName="ul">{`Hikari: Defend`}</li>
        <li parentName="ul">{`Partitio: Defend`}</li>
        <li parentName="ul">{`Throne: AC`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-6"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Merchant 1: HHG x4`}</li>
        <li parentName="ul">{`Merchant 2: Collect x4`}</li>
        <li parentName="ul">{`Throne: HP Thief x4`}</li>
      </ul>
    </Battle>
    <p>{`Go to Tavern, `}<strong parentName="p">{`Hear a Tale Hikari`}</strong>{`.`}</p>
    <h3 {...{
      "id": "wellgrove-hikari-ch3"
    }}>{`Wellgrove (Hikari Ch3)`}</h3>
    <p>{`Pick `}<strong parentName="p">{`$10000`}</strong>{`. Switch to Night for battle, Catapult x3`}<br parentName="p"></br>{`
`}{`Challenge: Defend, HHB x4`}</p>
    <p>{`TP `}<strong parentName="p">{`Stormhail`}</strong>{`.`}</p>
    <h3 {...{
      "id": "stormhail-hikari-ch4"
    }}>{`Stormhail (Hikari Ch4)`}</h3>
    <p>{`Switch to Night.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "items-3"
      }}>{`Items`}</h5>
      <ul>
        <li parentName="ul">{`Nuts to Throne`}</li>
      </ul>
    </Menu>
    <h5 {...{
      "id": "kunzo"
    }}>{`Kunzo`}</h5>
    <p>{`HHG x3, HP Thief x3`}</p>
    <Battle mdxType="Battle">
      <blockquote>
        <p parentName="blockquote">{`Watch Throne Latent during this fight, need it full at the end.`}</p>
      </blockquote>
      <h4 {...{
        "id": "rai-mei-55000hp-7s-sword-staff-ice-light-36000-collect"
      }}>{`Rai Mei 55000HP 7S (Sword Staff Ice Light) $36000 Collect`}</h4>
      <h5 {...{
        "id": "turn-1-11"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Crit Scope`}</li>
        <li parentName="ul">{`Hikari: Defend`}</li>
        <li parentName="ul">{`Partitio: Latent HHB x4`}</li>
        <li parentName="ul">{`Temenos: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-12"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Temenos: Attack x4`}</li>
        <li parentName="ul">{`Hikari: Collect x4`}</li>
        <li parentName="ul">{`Partitio: Defend / HHG x3 if Crit Scope before HHB x4`}</li>
        <li parentName="ul">{`Throne: HP Thief x4`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-7"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Partitio: HHG x4`}</li>
      </ul>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Sai`}</strong>{`, head to `}<strong parentName="p">{`Ku`}</strong>{`.`}<br parentName="p"></br>{`
`}<em parentName="p">{`Optionally`}</em>{` Kill pre Ku battle with Night + Catapult.`}</p>
    <h3 {...{
      "id": "ku-hikari-ch5"
    }}>{`Ku (Hikari Ch5)`}</h3>
    <p><strong parentName="p">{`If Throne isn't full latent, stay at inn`}</strong>{`.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "ritsu-75000hp-7s-spear-bow-fire-shadow-10000-collect"
      }}>{`Ritsu 75000HP 7S (Spear Bow Fire Shadow) $10000 Collect`}</h4>
      <h5 {...{
        "id": "turn-1-12"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Crit Scope`}</li>
        <li parentName="ul">{`Hikari: Spear`}</li>
        <li parentName="ul">{`Partitio: Latent Attack x3`}</li>
        <li parentName="ul">{`Temenos: Latent Attack x3`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-13"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Throne: HP Thief x4`}</li>
        <li parentName="ul">{`Hikari: HHG x4`}</li>
        <li parentName="ul">{`Partitio: HHB x4`}</li>
        <li parentName="ul">{`Temenos: Sacred Shield Throne`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-8"
      }}>{`Turn 3`}</h5>
      <p>{`Olive if needed, Collect, Attack`}</p>
    </Battle>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "king-mugen-80000hp-6s-spear-axe-thunder-light-18000-collect"
      }}>{`King Mugen 80000HP 6S (Spear Axe Thunder Light) $18000 Collect`}</h4>
      <h5 {...{
        "id": "turn-1-13"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Crit Scope`}</li>
        <li parentName="ul">{`Hikari: Defend`}</li>
        <li parentName="ul">{`Partitio: Latent Attack x3`}</li>
        <li parentName="ul">{`Temenos: Latent Attack x3`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-14"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Throne: HP Thief x4`}</li>
        <li parentName="ul">{`Hikari: HHB x4 / HHG x4`}</li>
        <li parentName="ul">{`Partitio: HHB x4`}</li>
        <li parentName="ul">{`Temenos: Attack / L Stone`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-9"
      }}>{`Turn 3`}</h5>
      <p>{`Collect + Attack`}</p>
    </Battle>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "hikari-25000hp-7s-sword-axe-light"
      }}>{`"Hikari" 25000HP 7S (Sword Axe Light)`}</h4>
      <ul>
        <li parentName="ul">{`Defend, HHV x4, HHG x4`}</li>
      </ul>
    </Battle>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "enshrouded-king-10s-sword-spear-bow-staff-thunder-wind-collect-26000"
      }}>{`Enshrouded King 10S (Sword Spear Bow Staff Thunder Wind) Collect $26000`}</h4>
      <h5 {...{
        "id": "turn-1-14"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Crit Scope`}</li>
        <li parentName="ul">{`Hikari: Pom M/L Self`}</li>
        <li parentName="ul">{`Partitio: Latent Attack x4`}</li>
        <li parentName="ul">{`Temenos: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-15"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Temenos: Latent Elemental Barrage x4`}</li>
        <li parentName="ul">{`Throne: AC`}</li>
        <li parentName="ul">{`Hikari: Hienka if before Throne, HHB x3`}</li>
        <li parentName="ul">{`Partitio: Lion Dance Throne`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-10"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Throne: `}<strong parentName="li">{`LATENT`}</strong>{` HP Thief x3, HP Thief x3`}</li>
        <li parentName="ul">{`Merchant 1: Collect x4`}</li>
        <li parentName="ul">{`Merchant 2: HHB x4`}</li>
      </ul>
      <p><em parentName="p">{`Try to watch JP on Throne here, want 5000JP.`}</em></p>
    </Battle>
    <p>{`Steal `}<strong parentName="p">{`Fort S`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Go to Tavern, `}<strong parentName="p">{`Swap Agnea > Hikari`}</strong><br parentName="p"></br>{`
`}{`Switch to night, Entreat `}<strong parentName="p">{`Light Nut L`}</strong>{` from Zeto.`}</p>
    <p>{`TP `}<strong parentName="p">{`Crackridge Harbor`}</strong>{`.`}</p>
    <h3 {...{
      "id": "crackridge-harbor"
    }}>{`Crackridge Harbor`}</h3>
    <p>{`Go buy `}<strong parentName="p">{`Battle-Tested Blade`}</strong>{` from Bandelam`}<br parentName="p"></br>{`
`}{`TP `}<strong parentName="p">{`Sai`}</strong>{`.`}</p>
    <h4 {...{
      "id": "sai-agnea-ch4"
    }}>{`Sai (Agnea Ch4)`}</h4>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "items-4"
      }}>{`Items`}</h5>
      <ul>
        <li parentName="ul">{`Nuts: Throne`}</li>
        <li parentName="ul">{`BT Blade: Throne`}</li>
      </ul>
      <h5 {...{
        "id": "jobs-8"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Armsmaster (Can learn Aebers here if enough JP)`}</li>
        <li parentName="ul">{`Agnea: Merchant`}</li>
        <li parentName="ul">{`Temenos: Inventor`}</li>
      </ul>
    </Menu>
    <Battle mdxType="Battle"> 
      <h4 {...{
        "id": "veronica-60000hp-6s-dagger-axe-fire-ice-shadow-12000-collect"
      }}>{`Veronica 60000HP 6S (Dagger Axe Fire Ice Shadow) $12000 Collect`}</h4>
      <blockquote>
        <p parentName="blockquote">{`If Aebers learned, break + crit scope + aebers`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1-15"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Throne: HP Thief x3`}</li>
        <li parentName="ul">{`Agnea: Donate BP x3 Throne`}</li>
        <li parentName="ul">{`Partitio: Latent Dagger x4`}</li>
        <li parentName="ul">{`Temenos: Spring Boots Throne`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-16"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Surprise Attack x4`}</li>
      </ul>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Merry Hills`}</strong>{`.`}</p>
    <h3 {...{
      "id": "merry-hills-agnea-ch5"
    }}>{`Merry Hills (Agnea Ch5)`}</h3>
    <p>{`Kill fight with Beastlings x3`}</p>
    <p>{`Buy/Steal (65%) `}<strong parentName="p">{`Quick Cloak & Ice M`}</strong>{`. (Money is tight, probably steal. Will need to sell if buying it)`}</p>
    <Menu mdxType="Menu">
      <p>{`If needed, can sell Carnage Bow, Eclipse Edge`}</p>
      <h5 {...{
        "id": "weapon-shop-buy"
      }}>{`Weapon Shop Buy`}</h5>
      <ul>
        <li parentName="ul">{`Swift Shield`}</li>
        <li parentName="ul">{`Dazzling Tiara`}</li>
      </ul>
      <h5 {...{
        "id": "equipment-1"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Optimize`}</li>
      </ul>
      <h5 {...{
        "id": "learn-skills-2"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Aebers`}</li>
        <li parentName="ul"><em parentName="li">{`If enough JP`}</em>{` Temenos: Aelfrics`}</li>
      </ul>
    </Menu>
    <p><strong parentName="p">{`SWITCH TO NIGHT`}</strong></p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "dolciana-p1-58000hp-6s-spear-dagger-bow-ice-shadow"
      }}>{`Dolciana P1 58000HP 6S (Spear Dagger Bow Ice Shadow)`}</h4>
      <h5 {...{
        "id": "turn-1-16"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Defend`}</li>
        <li parentName="ul">{`Agnea: Attack x3`}</li>
        <li parentName="ul">{`Temenos: Latent Attack x3`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-17"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Aebers`}</li>
      </ul>
    </Battle>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "dolciana-p2-90000hp-8s-sword-dagger-axe-fire-wind"
      }}>{`Dolciana P2 90000HP 8S (Sword Dagger Axe Fire Wind)`}</h4>
      <h5 {...{
        "id": "turn-1-17"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Throne: HP Thief`}</li>
        <li parentName="ul">{`Agnea: Attack x3`}</li>
        <li parentName="ul">{`Partitio: Latent Dagger x4`}</li>
        <li parentName="ul">{`Temenos: Crit Scope`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-18"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Throne: LATENT Aebers + HP Thief`}</li>
      </ul>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Beastling Bay Anchorage`}</strong>{`, Take boat to `}<strong parentName="p">{`Roque Island`}</strong></p>
    <h3 {...{
      "id": "roque-island-partitio-ch4"
    }}>{`Roque Island (Partitio Ch4)`}</h3>
    <p><strong parentName="p">{`SWITCH TO NIGHT`}</strong>{` after Purchasting Rights.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "steam-tank-obsidian-70000hp-8s-spear-bow-shadow-collect-52000"
      }}>{`Steam Tank Obsidian 70000HP 8S (Spear Bow Shadow) Collect $52000`}</h4>
      <h5 {...{
        "id": "turn-1-18"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Defend`}</li>
        <li parentName="ul">{`Agnea: Attack`}</li>
        <li parentName="ul">{`Partitio: Attack`}</li>
        <li parentName="ul">{`Temenos: Crit Scope`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-19"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Aebers `}</li>
        <li parentName="ul">{`Merchant 1: Collect x4`}</li>
        <li parentName="ul">{`Merchant 2: HHV x4`}</li>
      </ul>
    </Battle>
    <h3 {...{
      "id": "montwise-throne-ch3-continued"
    }}>{`Montwise (Throne Ch3 continued)`}</h3>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "father-58000hp-7s-spear-dagger-axe-wind-light-collect-9600"
      }}>{`Father 58000HP 7S (Spear Dagger Axe Wind Light) Collect $9600`}</h4>
      <h5 {...{
        "id": "turn-1-19"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Defend`}</li>
        <li parentName="ul">{`Partitio: HHB x4`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-20"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Aebers`}</li>
        <li parentName="ul">{`Attack after dialogue`}</li>
      </ul>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Wellgrove`}</strong></p>
    <h3 {...{
      "id": "wellgrove-throne-ch3"
    }}>{`Wellgrove (Throne Ch3)`}</h3>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "mother-42000hp-6s-dagger-bow-ice-light-collect-6000"
      }}>{`Mother 42000HP 6S (Dagger Bow Ice Light) Collect $6000`}</h4>
      <h5 {...{
        "id": "turn-1-20"
      }}>{`Turn 1`}</h5>
      <p>{`Throne Defend Rest Attack`}</p>
      <h5 {...{
        "id": "turn-2-21"
      }}>{`Turn 2`}</h5>
      <p>{`Aebers, rest Attack`}</p>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`New Delsta`}</strong></p>
    <h3 {...{
      "id": "new-delsta-throne-ch4"
    }}>{`New Delsta (Throne Ch4)`}</h3>
    <p>{`After Ambush switch back to day`}<br parentName="p"></br>{`
`}{`Buy `}<strong parentName="p">{`Forbidden Elixer`}</strong></p>
    <p>{`Heal before Claude, `}<strong parentName="p">{`Switch to Night`}</strong>{`.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "claude-68000hp-9s-dagger-axe-staff-thunder-light-30000-collect"
      }}>{`Claude 68000HP 9S (Dagger Axe Staff Thunder Light) $30000 Collect`}</h4>
      <h5 {...{
        "id": "turn-1-21"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Defend`}</li>
        <li parentName="ul">{`Agnea: Defend / Nothing`}</li>
        <li parentName="ul">{`Partitio: HHV x4`}</li>
        <li parentName="ul">{`Temenos: Crit Scope`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-22"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Aebers`}</li>
        <li parentName="ul">{`Agnea: Stimulate to put someone between Claude's turns, or if you can't HHM`}</li>
        <li parentName="ul">{`Rest: Defend till Claude acts, then Attack.`}</li>
      </ul>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Beastling Bay: Anchorage`}</strong>{`, run to Beastling Village.`}<br parentName="p"></br>{`
`}{`Talk to Ochette, `}<strong parentName="p">{`CHOOSE AKALA`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "remove"
      }}>{`Remove`}</h5>
      <ul>
        <li parentName="ul">{`Agnea`}</li>
        <li parentName="ul">{`Partitio`}</li>
      </ul>
      <h5 {...{
        "id": "add"
      }}>{`Add`}</h5>
      <ul>
        <li parentName="ul">{`Ochette`}</li>
      </ul>
    </Menu>
    <p>{`TP `}<strong parentName="p">{`Crackridge`}</strong></p>
    <h3 {...{
      "id": "crackridge-ochette-ch2-tera"
    }}>{`Crackridge (Ochette Ch2 Tera)`}</h3>
    <p>{`Switch to night, run out and look for Meep battle.`}</p>
    <p>{`Battle: Temenos Spring Boots Ochette, Throne Thunder M`}<br parentName="p"></br>{`
`}{`Ochette Capture, clear battle trying to keep Ochette alive.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "items-5"
      }}>{`Items`}</h5>
      <p>{`Nourish M, Nourish L x2 Ochette`}</p>
      <h5 {...{
        "id": "equip-skills-9"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Throne: -Life in the Shadow +Summon Strength`}</li>
        <li parentName="ul">{`Temenos: -Grow on Trees +Evasive Maneuvers`}</li>
        <li parentName="ul">{`Ochette: A Step Ahead`}</li>
      </ul>
    </Menu>
    <p>{`After befriending Pom switch back to day, then `}<strong parentName="p">{`switch to night`}</strong>{` before Tera.`}</p>
    <Battle mdxType="Battle">
      <blockquote>
        <p parentName="blockquote">{`Check to make sure Temenos' Latent is full. If not Stay at Inn before Ch3`}</p>
      </blockquote>
      <h4 {...{
        "id": "terakun-43500hp-6s-dagger-axe-staff-ice-light"
      }}>{`Terakun 43500HP 6S (Dagger Axe Staff Ice Light)`}</h4>
      <h5 {...{
        "id": "turn-1-22"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Defend`}</li>
        <li parentName="ul">{`Temenos: Crit Scope (Shouldn't be needed)`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-23"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Aebers`}</li>
        <li parentName="ul">{`Ochette: Capture`}</li>
      </ul>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Conning Creek`}</strong>{`.`}</p>
    <h3 {...{
      "id": "conning-creek-ochette-ch2-acta"
    }}>{`Conning Creek (Ochette Ch2 Acta)`}</h3>
    <p>{`Provoke M Stone`}<br parentName="p"></br>{`
`}{`TP `}<strong parentName="p">{`Stormhail`}</strong></p>
    <h3 {...{
      "id": "stormhail-ochette-ch2-glacis"
    }}>{`Stormhail (Ochette Ch2 Glacis)`}</h3>
    <p>{`Provoke: Any Stone (Ice S should be good enough, Ice L saves animation time), Defend, Tera`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "glacis-54000hp-8s-spear-dagger-bow-fire"
      }}>{`Glacis 54000HP 8S (Spear Dagger Bow Fire)`}</h4>
      <h5 {...{
        "id": "turn-1-23"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Defend`}</li>
        <li parentName="ul">{`Temenos: Crit Scope`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-24"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Aebers`}</li>
        <li parentName="ul">{`Ochette: Capture`}</li>
      </ul>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Beastling Village`}</strong></p>
    <h3 {...{
      "id": "beastling-village-ochette-ch3"
    }}>{`Beastling Village (Ochette Ch3)`}</h3>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs-9"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Inventor`}</li>
        <li parentName="ul">{`Temenos: `}<strong parentName="li">{`Aelfrics`}</strong>{`, Armsmaster`}</li>
        <li parentName="ul">{`Ochette: Merchant, 1st 3 Skills`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills-10"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Ochette: +A Step Ahead +Grow On Trees +Boost Start`}</li>
      </ul>
    </Menu>
    <p>{`Go to Summit. `}<strong parentName="p">{`Switch to Night`}</strong>{`.`}</p>
    <p>{`3 Battles: Catapult x3`}</p>
    <p><strong parentName="p">{`SWITCH TO NIGHT`}</strong>{` for Malamaowl`}</p>
    <p><strong parentName="p">{`Need Latent on Throne for T1 Break, Need Latent on Temenos PERIOD`}</strong></p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "malamaowl-96000hp-7s-dagger-axe-fire"
      }}>{`Malamaowl 96000HP 7S (Dagger Axe Fire)`}</h4>
      <h5 {...{
        "id": "turn-1-24"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Latent HP Thief x3, Reinforcing Jam`}</li>
        <li parentName="ul">{`Temenos: Latent Sixfold Strike`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-25"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Throne: LATENT Aebers, HP Thief x3`}</li>
        <li parentName="ul">{`Temenos: Defend`}</li>
        <li parentName="ul">{`Ochette: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-11"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Armor Corrosive`}</li>
        <li parentName="ul">{`Ochette: Donate BP Throne`}</li>
        <li parentName="ul">{`Temenos: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-4-1"
      }}>{`Turn 4`}</h5>
      <ul>
        <li parentName="ul">{`All Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-5-1"
      }}>{`Turn 5`}</h5>
      <ul>
        <li parentName="ul">{`Surprise Attack x3`}</li>
      </ul>
      <p>{`If he eats Temenos first, Sacred Shield Throne, heal her after eat, and have her Spring Boots herself.`}<br parentName="p"></br>{`
`}{`Don't need Donate BP Anymore.`}</p>
      <p>{`So something like:`}<br parentName="p"></br>{`
`}{`T3: Throne - Spring Boots, Temenos: Sacred Shield x4 Throne`}<br parentName="p"></br>{`
`}{`T4: Throne - Heal Temenos or something. Others can heal Throne if possible.`}<br parentName="p"></br>{`
`}{`T5: Throne - Refreshing Jam Self`}<br parentName="p"></br>{`
`}{`T6: Aebers`}</p>
    </Battle>
    <p>{`Go to Tavern, change party members.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "party-2"
      }}>{`Party`}</h5>
      <ul>
        <li parentName="ul">{`Add Oswald`}</li>
        <li parentName="ul">{`Partitio > Ochette`}</li>
      </ul>
      <h5 {...{
        "id": "jobs-10"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Oswald: Merchant`}</li>
      </ul>
    </Menu>
    <p>{`TP `}<strong parentName="p">{`Montwise`}</strong>{`.`}</p>
    <h3 {...{
      "id": "montwise-oswald--partitio-ch2"
    }}>{`Montwise (Oswald & Partitio Ch2)`}</h3>
    <p>{`Switch to night.`}<br parentName="p"></br>{`
`}{`Catapult x3 first 2 Battles, Mug HHG x4.`}<br parentName="p"></br>{`
`}{`TP `}<strong parentName="p">{`Flamechurch`}</strong>{`.`}</p>
    <h3 {...{
      "id": "flamechurch-temenos--throne-ch1"
    }}>{`Flamechurch (Temenos & Throne Ch1)`}</h3>
    <p>{`Go to Tavern.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "party-3"
      }}>{`Party`}</h5>
      <ul>
        <li parentName="ul">{`Castti > Oswald`}</li>
        <li parentName="ul">{`Partitio > Ochette`}</li>
      </ul>
    </Menu>
    <p>{`Coerce Old Man: LATENT Sixfold, or if no Latent Mystic Staff, Staff x4`}<br parentName="p"></br>{`
`}{`Guide Old Man`}</p>
    <p>{`Steal `}<strong parentName="p">{`Reinforcing Jam`}</strong>{` (Woman left of the Sacred Flame)`}<br parentName="p"></br>{`
`}{`Finish Chapter. TP `}<strong parentName="p">{`Cropdale`}</strong>{`.`}</p>
    <h3 {...{
      "id": "cropdale-castti--ochette-1"
    }}>{`Cropdale (Castti & Ochette 1)`}</h3>
    <p>{`Duorduor: HP Thief x3 (Daytime)`}<br parentName="p"></br>{`
`}{`After finishing TP `}<strong parentName="p">{`Cropdale`}</strong>{` to start part 2`}</p>
    <p>{`Wriggling Shadow: Akala, Akala, Glacis, L Stone`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "creeping-shadow-50000hp-6s-spear-axe-bow-ice-light"
      }}>{`Creeping Shadow 50000HP 6S (Spear Axe Bow Ice Light)`}</h4>
      <ul>
        <li parentName="ul">{`Throne Defend, Others Axe/Spear x3`}</li>
        <li parentName="ul">{`Throne Aebers`}</li>
      </ul>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Ryu`}</strong>{`.`}</p>
    <h3 {...{
      "id": "ryu-1"
    }}>{`Ryu`}</h3>
    <p>{`Talk to Tavern Keeper.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "party-4"
      }}>{`Party`}</h5>
      <ul>
        <li parentName="ul">{`Hikari > Ochette`}</li>
        <li parentName="ul">{`Castti > Agnea`}</li>
      </ul>
      <h5 {...{
        "id": "jobs-11"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Hikari: Merchant, 1 Skill`}</li>
      </ul>
    </Menu>
    <p>{`Do Quest. TP `}<strong parentName="p">{`Ku`}</strong>{`.`}</p>
    <h3 {...{
      "id": "ku-hikari--agnea-ch2"
    }}>{`Ku (Hikari & Agnea Ch2)`}</h3>
    <p>{`After Entreating on 2nd screen, TP `}<strong parentName="p">{`Conning Creek`}</strong></p>
    <h3 {...{
      "id": "conning-creek-temenos--throne-ch2"
    }}>{`Conning Creek (Temenos & Throne Ch2)`}</h3>
    <p>{`After Stealing map, TP `}<strong parentName="p">{`Ku`}</strong>{`.`}</p>
    <p><strong parentName="p">{`Yomi`}</strong>{`: Defend, HHV x4 (range), (Light) L Stone if alive`}<br parentName="p"></br>{`
`}{`Finish Hikari & Agnea Chapter`}</p>
    <p>{`TP `}<strong parentName="p">{`Conning Creek`}</strong>{`, and head to `}<strong parentName="p">{`Cave of the Sun and Moon`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Finish Temenos & Throne chapter.`}</p>
    <p>{`TP `}<strong parentName="p">{`Oresrush`}</strong>{`, head to campsite to start `}<strong parentName="p">{`Journey of the Dusk`}</strong></p>
    <h3 {...{
      "id": "journey-of-the-dusk"
    }}>{`Journey of the Dusk`}</h3>
    <p>{`Forced Battle: Catapult x4`}</p>
    <p>{`Head to `}<strong parentName="p">{`Tranquil Grotto`}</strong>{`, run from random battles. Light Flame.`}</p>
    <p>{`TP `}<strong parentName="p">{`Beastling Village`}</strong>{` and do that one. Before the boss:`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "formation-1"
      }}>{`Formation`}</h5>
      <ul>
        <li parentName="ul">{`Ochette > Agnea`}</li>
        <li parentName="ul">{`Hikari > Castti`}</li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "grotesque-monster-120000hp-7s-axe-bow-ice-thunder"
      }}>{`Grotesque Monster 120000HP 7S (Axe Bow Ice Thunder)`}</h4>
      <h5 {...{
        "id": "turn-1-25"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Crit Scope`}</li>
        <li parentName="ul">{`Temenos: (1L) Bow x3 `}</li>
        <li parentName="ul">{`Castti, Ochette: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-26"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Castti, Ochette: Attack x4`}</li>
        <li parentName="ul">{`Throne: Aebers`}</li>
        <li parentName="ul">{`Temenos: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-12"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Temenos: Pom L Throne`}</li>
        <li parentName="ul">{`Throne: Aebers`}</li>
      </ul>
    </Battle>
    <p>{`After lighting Flame TP `}<strong parentName="p">{`Flamechurch`}</strong>{`.`}</p>
    <h3 {...{
      "id": "flamechurch-1"
    }}>{`Flamechurch`}</h3>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "arcanette-150000hp-8s-spear-axe-ice-thunder"
      }}>{`Arcanette 150000HP 8S (Spear Axe Ice Thunder)`}</h4>
      <h5 {...{
        "id": "turn-1-26"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Crit Scope`}</li>
        <li parentName="ul">{`Castti, Ochette: Defend`}</li>
        <li parentName="ul">{`Temenos: (2L/2R) Axe/Spear x3`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-27"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Castti, Ochette: Axe x4`}</li>
        <li parentName="ul">{`Throne: Aebers`}</li>
        <li parentName="ul">{`Temenos: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-13"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Temenos: Rev Jam Throne`}</li>
        <li parentName="ul">{`Throne: Aebers`}</li>
      </ul>
    </Battle>
    <p>{`Light Flame, TP `}<strong parentName="p">{`Crackridge`}</strong>{` next. `}</p>
    <h3 {...{
      "id": "crackridge"
    }}>{`Crackridge`}</h3>
    <p>{`If Temenos & Throne Latent not full, rest at inn.`}<br parentName="p"></br>{`
`}{`Before lighting flame menu.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs-12"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Armsmaster`}</li>
        <li parentName="ul">{`Temenos: Warrior`}</li>
        <li parentName="ul">{`Castti: Dancer`}</li>
        <li parentName="ul">{`Ochette: Merchant, `}<strong parentName="li">{`Hired Help`}</strong></li>
        <li parentName="ul">{`Agnea: Inventor`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills-11"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Throne: -Boost Start +Fleetfoot`}</li>
        <li parentName="ul">{`Partitio: -EM +Hang Tough`}</li>
        <li parentName="ul">{`Hikari: +Hang Tough`}</li>
        <li parentName="ul">{`Ochette: +Hang Tough`}</li>
      </ul>
      <p>{`Close and open menu.`}</p>
      <h5 {...{
        "id": "formation-2"
      }}>{`Formation`}</h5>
      <ul>
        <li parentName="ul">{`Partitio > Castti`}</li>
        <li parentName="ul">{`Ochette > Oswald`}</li>
      </ul>
      <h5 {...{
        "id": "items-6"
      }}>{`Items`}</h5>
      <p>{`Shiny Mirror`}</p>
    </Menu>
    <p>{`After Lighting Flame, do this menu.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "formation-3"
      }}>{`Formation`}</h5>
      <ul>
        <li parentName="ul">{`Hikari > Partitio`}</li>
      </ul>
      <h5 {...{
        "id": "world-map"
      }}>{`World Map`}</h5>
      <ul>
        <li parentName="ul">{`TP `}<strong parentName="li">{`New Delsta Anchorage`}</strong></li>
      </ul>
    </Menu>
    <p>{`TP `}<strong parentName="p">{`New Delsta Anchorage`}</strong>{`, go to `}<strong parentName="p">{`Vidania`}</strong>{`.`}</p>
    <h3 {...{
      "id": "vidania"
    }}>{`Vidania`}</h3>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "vide-200000hp"
      }}>{`Vide 200000HP`}</h4>
      <h5 {...{
        "id": "turn-1-27"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Throne: LATENT Reinforcing, Aebers`}</li>
        <li parentName="ul">{`Other 3: First 2 Defend, last Attack x3 `}<strong parentName="li">{`Vide`}</strong></li>
        <li parentName="ul"><em parentName="li">{`Done this way for cursor manipulation, so cursor stays on Vide`}</em></li>
      </ul>
      <h5 {...{
        "id": "turn-2-28"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Defenders: Attack x4`}</li>
        <li parentName="ul">{`Throne: LATENT Aebers, Forbidden Elixer, or vice versa if not Pom'd yet.`}</li>
        <li parentName="ul">{`Other Character: Pom L Throne.`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-14"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Throne: LATENT Surprise Attack x3, Aebers`}</li>
        <li parentName="ul">{`Rest: If low crits can chuck Ls.`}</li>
      </ul>
      <p>{`Party gets eaten`}</p>
      <h5 {...{
        "id": "turn-5-2"
      }}>{`Turn 5`}</h5>
      <ul>
        <li parentName="ul">{`(2D) Attack or HHV x4 if low damage`}<br parentName="li"></br>
          <em parentName="li">{`If very underdamaged, can use ruffians, 2x HHV, Spring Boots, Crit Scope, plenty of tools to make up damage.`}</em></li>
      </ul>
    </Battle>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "vide-phase-2-250000hp"
      }}>{`Vide Phase 2 250000HP`}</h4>
      <h5 {...{
        "id": "turn-1-28"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Agnea: Latent Springy Boots`}</li>
        <li parentName="ul">{`Ochette: Beastly Howl`}</li>
        <li parentName="ul">{`Partitio: Latent HHB x4`}</li>
        <li parentName="ul">{`Castti: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-29"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Castti: Lion Dance x2 Throne (1D)`}</li>
        <li parentName="ul">{`Agnea: Crit Scope Vide (1U)`}</li>
        <li parentName="ul">{`Ochette: HHV x4`}</li>
        <li parentName="ul">{`Partitio: HHV x3`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-15"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Agnea: Attack x3`}</li>
        <li parentName="ul">{`Ochette: Beastly Howl`}</li>
        <li parentName="ul">{`Partitio: `}<strong parentName="li">{`Bow`}</strong>{` x4`}</li>
      </ul>
      <p>{`Party dies now.`}</p>
      <h5 {...{
        "id": "turn-4-2"
      }}>{`Turn 4`}</h5>
      <ul>
        <li parentName="ul">
          <p parentName="li">{`Throne: Swift Step`}</p>
        </li>
        <li parentName="ul">
          <p parentName="li">{`Temenos: Aelfrics Throne`}</p>
        </li>
        <li parentName="ul">
          <p parentName="li">{`Hikari: Attack x4`}</p>
        </li>
        <li parentName="ul">
          <p parentName="li">{`Throne: LATENT Aebers, Pom L Self`}</p>
        </li>
      </ul>
      <h5 {...{
        "id": "turn-5-3"
      }}>{`Turn 5`}</h5>
      <ul>
        <li parentName="ul">
          <p parentName="li">{`Throne: Aebers`}</p>
        </li>
        <li parentName="ul">
          <p parentName="li">{`Someone after her: Pom L Throne`}</p>
        </li>
        <li parentName="ul">
          <p parentName="li">{`Throne: Aebers`}</p>
        </li>
      </ul>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Oresrush`}</strong>{` Go to campsite, start Epilogue. Timing ends after 2nd cutscene black screen. GG!`}</p>
    <hr></hr>
    <h3 {...{
      "id": "changelog"
    }}>{`Changelog`}</h3>
    <p>{`Current Version: 1.0.1`}</p>
    <h6 {...{
      "id": "100-initial-route"
    }}>{`1.0.0: Initial Route`}</h6>
    <h6 {...{
      "id": "101-update-thurston-fight-to-include-collect"
    }}>{`1.0.1: Update Thurston fight to include Collect`}</h6>
    <h6 {...{
      "id": "110"
    }}>{`1.1.0:`}</h6>
    <ul>
      <li parentName="ul">{`Cheaper/faster Partitio 1.`}</li>
      <li parentName="ul">{`Restructure early game. Get Temenos later, fight Clarissa earlier, get EM on the way to Conning Creek.`}</li>
      <li parentName="ul">{`Consistent Garnet.`}</li>
    </ul>
    <h6 {...{
      "id": "120-giants-club-cut--reroute"
    }}>{`1.2.0: Giant's Club Cut / Reroute`}</h6>
    <ul>
      <li parentName="ul">{`Cut Giant's Club`}</li>
      <li parentName="ul">{`Diamond Dagger instead of Lockpick`}</li>
      <li parentName="ul">{`Delay Temenos chapters until after Champ Belt`}</li>
      <li parentName="ul">{`Remove Step Ahead for Lategame.`}</li>
      <li parentName="ul">{`Hikari for Phase 2, Oswald Phase 1`}</li>
    </ul>
    <h6 {...{
      "id": "121"
    }}>{`1.2.1:`}</h6>
    <ul>
      <li parentName="ul">{`Temenos Inventor until Champ Belt`}</li>
      <li parentName="ul">{`Summon Str Ochette Chapters`}</li>
      <li parentName="ul">{`Fix errors / cleanup`}</li>
    </ul>
    <h6 {...{
      "id": "122-31820222"
    }}>{`1.2.2 3/18/20222`}</h6>
    <ul>
      <li parentName="ul">{`Keep Temenos Scholar for Trosseau, no need for early Sharp L`}</li>
      <li parentName="ul">{`Crit Scope for Tera-kun`}</li>
      <li parentName="ul">{`More precise Inn stays`}</li>
    </ul>
    <h3 {...{
      "id": "ideas--things-to-investigate"
    }}>{`Ideas / Things to Investigate`}</h3>
    <ul>
      <li parentName="ul">{`Throne Start`}</li>
      <li parentName="ul">{`Cut White Powder Quest (money still seems necessary and Crit M is nice)`}</li>
      <li parentName="ul">{`Calculate money, see if we can use HHB instead of HHG in problematic spots`}</li>
      <li parentName="ul">{`See how much end game HHB usage we can have`}</li>
      <li parentName="ul"><del parentName="li">{`Look into Vide kill, barely missed it once in practice (90k, 99k, 52k).`}</del><ul parentName="li">
          <li parentName="ul">{`Can fix easily with Crit Scope since we don't need plum.`}</li>
        </ul></li>
      <li parentName="ul"><del parentName="li">{`Route in Flamechurch candle quest, to skip battles in Dusk segment.`}</del><ul parentName="li">
          <li parentName="ul">{`No good time to turn in quest, can't do it after Arcanette.`}</li>
        </ul></li>
      <li parentName="ul"><del parentName="li">{`Test Assasins on Yomi`}</del>{` Jello tested, same range. Best to fill range with Light L.`}</li>
      <li parentName="ul">{`HHB x3 or x4 on Partitio & Temenos 2 fights`}</li>
      <li parentName="ul">{`Look into Diamond Dagger purchase in Merry Hills`}</li>
      <li parentName="ul">{`Swap Hikari and Oswald roles in Vide fight, so I can carry Hikari with me for Dawn segment`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      